import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, CardColors, CardVariants, HeroCard } from '@/ui'
import { useAnalyticsTrack } from '@/featuresV1/Amplitude'

const config = {
  taxDeductions: {
    key: 'NEW_ON_HOMEPAGE_BANNER_KEY_MAXIMIZE_TAX_DEDUCTIONS',
    image: 'https://heard-images.s3.amazonaws.com/assets/home-sparkles.svg',
    imageAlt: 'Sparkling house',
    title: 'What’s new on the Home page',
    description: (
      <>
        Check out <strong>Maximize Tax Deductions</strong>, which tracks your
        year-to-date tax savings from business expense deductions and offers
        tips on how to lower your tax liability. Stay tuned for upcoming
        enhancements featuring more personalized insights and reporting.
      </>
    ),
    link: null,
  },
  mtdGoals: {
    key: 'NEW_ON_HOMEPAGE_BANNER_KEY_MTD_GOALS',
    image: 'https://heard-images.s3.amazonaws.com/assets/chart-sparkles.svg',
    imageAlt: 'Sparkling chart',
    title: 'Practice Goal Setting and Real Time Income Tracking',
    description: (
      <>
        Set goals for practice income, expenses, and profit with personalized
        guidance to help your practice succeed. Plus, track your practice&apos;s
        monthly income in real-time and compare performance to previous months
        (based on available historical data).
        <br />
        <br />
        Practice Insights can now be found under the &quot;Insights&quot; menu
        on the left.
      </>
    ),
    link: '/goal-setting',
  },
}

export const NewOnHomepageBanner = ({
  feature,
}: {
  feature: keyof typeof config
}) => {
  const navigate = useNavigate()
  const { key, image, title, description, link, imageAlt } = config[feature]

  const track = useAnalyticsTrack()
  const [noticeDismissed, setNoticeDismissed] = useState(
    localStorage.getItem(key) === 'true'
  )

  const handleClose = useCallback(() => {
    track("clicked dismiss what's new banner")
    localStorage.setItem(key, 'true')
    setNoticeDismissed(true)
  }, [key, track])

  if (noticeDismissed) {
    return null
  }

  return (
    <HeroCard
      color={CardColors.LEVEL_1}
      imageAlt={imageAlt}
      imageSrc={image}
      imageWidth={250}
      onClose={handleClose}
      title={title}
      description={description}
      variant={CardVariants.ANNOUNCEMENT}
    >
      {link && (
        <Button
          onClick={() => {
            track('Clicked Get Started Goal Setting CTA')
            localStorage.setItem(key, 'true')
            navigate(link)
          }}
        >
          Get Started
        </Button>
      )}
    </HeroCard>
  )
}
